import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import StartScreen from './components/StartScreen';
import Game from './components/Game';
import ResultScreen from './components/ResultScreen';
import GameOver from './components/GameOver';

const AppRoutes = () => {
  return (
    <Box minH="100vh" bg="gray.50">
      <Routes>
        <Route path="/" element={<StartScreen />} />
        <Route path="/game" element={<Game />} />
        <Route path="/results" element={<ResultScreen />} />
        <Route path="/game-over" element={<GameOver />} />
      </Routes>
    </Box>
  );
};

export default AppRoutes; 